(() => {

  /* =========================
     DESKTOP: your existing swap
     ========================= */
  const initDesktop = (root) => {
    const isDesktop = window.matchMedia('(min-width: 981px)').matches;
    if (!isDesktop) return;

    const panels = [...root.querySelectorAll('.sw_panel[data-key]')];
    const imgs   = [...root.querySelectorAll('.sw_mediaImg[data-key]')];
    const chipEl  = root.querySelector('[data-poster-chip]');
    const titleEl = root.querySelector('[data-poster-title]');

    if (!panels.length || !imgs.length) return;

    let currentKey = null;

    const setActive = (key) => {
      if (key === currentKey) return;
      currentKey = key;

      imgs.forEach(img => {
        img.classList.toggle('is-active', img.dataset.key === key);
      });

      const panel = root.querySelector(`.sw_panel[data-key="${key}"]`);
      if (panel) {
        const chip  = panel.getAttribute('data-chip');
        const title = panel.getAttribute('data-title');
        if (chipEl && chip) chipEl.textContent = chip;
        if (titleEl && title) titleEl.textContent = title;
      }
    };

    setActive('intro');

    const onScroll = () => {
      const triggerY = window.innerHeight * 0.55;

      for (let i = panels.length - 1; i >= 0; i--) {
        const rect = panels[i].getBoundingClientRect();
        if (rect.top <= triggerY) {
          setActive(panels[i].dataset.key);
          return;
        }
      }
      setActive(panels[0].dataset.key);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  };


  /* =========================
     MOBILE: sticky actives deck
     ========================= */
  const initMobileActives = (root) => {
    const isMobile = window.matchMedia('(max-width: 980px)').matches;
    if (!isMobile) return;

    const actives = root.querySelector('[data-skn-actives]');
    if (!actives) return;

    const track = actives.querySelector('[data-skn-track]');
    const cards = [...actives.querySelectorAll('.skn-card[data-index]')];
    const pills = [...actives.querySelectorAll('.skn-pill[data-index]')];

    if (!track || cards.length === 0) return;

    const total = cards.length;

    // Set track height based on count (gives room to scroll-switch)
    // 1 card ≈ 85vh of scroll, plus a base.
    const trackVh = Math.max(220, 120 + total * 90);
    track.style.height = `${trackVh}vh`;

    let current = -1;

    const updateUI = (activeIndex) => {
      if (activeIndex === current) return;
      current = activeIndex;

      cards.forEach((card, idx) => {
        card.classList.remove('active', 'prev', 'next');
        if (idx === activeIndex) card.classList.add('active');
        else if (idx < activeIndex) card.classList.add('prev');
        else card.classList.add('next');
      });

      pills.forEach((pill, idx) => {
        pill.classList.toggle('active', idx === activeIndex);
      });
    };

    const getActiveIndexFromScroll = () => {
      const rect = track.getBoundingClientRect();
      const vh = window.innerHeight;

      // Sticky wrapper visible height (roughly)
      const stickyViewHeight = Math.min(720, vh - 88);
      const scrollable = rect.height - stickyViewHeight;

      if (scrollable <= 0) return 0;

      // Start switching a bit earlier for smoothness
      const offsetTop = 80;
      const scrolled = (rect.top - offsetTop) * -1;

      let progress = scrolled / scrollable;
      progress = Math.max(0, Math.min(0.9999, progress));

      const idx = Math.floor(progress * total);
      return Math.max(0, Math.min(total - 1, idx));
    };

    const onScroll = () => {
      updateUI(getActiveIndexFromScroll());
    };

    // Optional: click pill scroll-jump
    const scrollToIndex = (idx) => {
      const rect = track.getBoundingClientRect();
      const topAbs = window.scrollY + rect.top;

      const vh = window.innerHeight;
      const stickyViewHeight = Math.min(720, vh - 88);
      const scrollable = rect.height - stickyViewHeight;

      if (scrollable <= 0) return;

      const target = topAbs + (idx / total) * scrollable + 90; // +90 aligns with our offset
      window.scrollTo({ top: target, behavior: 'smooth' });
    };

    pills.forEach(p => {
      p.addEventListener('click', () => {
        const idx = parseInt(p.dataset.index, 10);
        if (!Number.isNaN(idx)) scrollToIndex(idx);
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // init
    updateUI(0);
    onScroll();
  };


  const boot = () => {
    document.querySelectorAll('[data-software-section]').forEach((root) => {
      initDesktop(root);
      initMobileActives(root);
    });
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

